import { defineComponent as _defineComponent } from 'vue'
import { auth0 } from "@/services/auth.service";
import { ref, onMounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'top-bar',
  setup(__props, { expose: __expose }) {
  __expose();

const username = ref("");

onMounted(async () => {
  if (auth0.isAuthenticated) {
    username.value = `${auth0.user.value?.given_name} ${auth0.user.value?.family_name}`;
    console.log("user", auth0.user.value);// JUST TESTING
  } else {
    handleLogout();
  }
});

// This method called while click on Logout button
const handleLogout = () => {
  // Log the user out of Auth0 using the SDK method
  auth0.logout({
    logoutParams: {
      // The clientId of your application.
      // If this property is not set, then the clientId that was used during initialization of the SDK 
      //      is sent to the logout endpoint.
      // If this property is set to null, then no client ID value is sent to the logout endpoint.
      client_id: process.env.VUE_APP_CLIENT_ID,
      // The URL where Auth0 will redirect your browser to after the logout.
      // Note: If the client_id parameter is included, 
      //      the returnTo URL that is provided must be listed in the Application's "Allowed Logout URLs" in the Auth0 dashboard.
      // However, if the client_id parameter is not included, 
      //      the returnTo URL must be listed in the "Allowed Logout URLs" at the account level in the Auth0 dashboard.
      returnTo: process.env.VUE_APP_POST_LOGOUT_REDIRECT_URI,
      // When supported by the upstream identity provider,
      //      forces the user to logout of their identity provider and from Auth0.
      federated: false,
    }
  });
};


const __returned__ = { username, handleLogout, get auth0() { return auth0 } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})